module.exports = __webpack_public_path__ + "img/ordenar-lista.7bc0eb13.svg";